// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__a94+w","container":"NotFound_container__gAlXI","img":"NotFound_img__aGlnA","imgContainer":"NotFound_imgContainer__e2SGT"};